const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const SUBSCRIPTION_CONFIG = {
  telecom: { type: "subscriber", label: "Abone Numarası" },
  mobile: { type: "service", label: "Hizmet Numarası" },
  utility: { type: "contract", label: "Sözleşme Numarası" },
  digital: { type: "customer", label: "Müşteri Numarası" },
  ecommerce: { type: "customer", label: "Müşteri Numarası" },
};

export const EMPTY_APPLICATION_INFO = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  privacyAccepted: false,
  subscriptionNumber: "",
  subscriptionNumberUnknown: false,
};

export function createEmptyApplicationInfo() {
  return { ...EMPTY_APPLICATION_INFO };
}

export function getSubscriptionField(company, companies) {
  const group = companies.find((item) => item.name === company)?.group;
  const config = SUBSCRIPTION_CONFIG[group] || {
    type: "subscriber_or_customer",
    label: "Abone / Müşteri Numarası",
  };
  return {
    ...config,
    placeholder: company
      ? `${company} ${config.label.toLocaleLowerCase("tr")}`
      : config.label,
  };
}

export function normalizeTurkishPhone(value) {
  const compact = value.replace(/[\s()-]/g, "");
  if (/^05\d{9}$/.test(compact)) return `+9${compact}`;
  if (/^5\d{9}$/.test(compact)) return `+90${compact}`;
  if (/^\+905\d{9}$/.test(compact)) return compact;
  return null;
}

export function isValidNationalId(value) {
  if (!/^\d{11}$/.test(value) || value[0] === "0") return false;
  const digits = value.split("").map(Number);
  const oddSum = digits[0] + digits[2] + digits[4] + digits[6] + digits[8];
  const evenSum = digits[1] + digits[3] + digits[5] + digits[7];
  return ((oddSum * 7 - evenSum) % 10 + 10) % 10 === digits[9]
    && digits.slice(0, 10).reduce((sum, digit) => sum + digit, 0) % 10 === digits[10];
}

export function validateApplicationInfo(values) {
  const errors = {};
  if (!values.firstName.trim()) errors.firstName = "Adınızı girin.";
  if (!values.lastName.trim()) errors.lastName = "Soyadınızı girin.";
  if (!EMAIL_PATTERN.test(values.email.trim())) errors.email = "Geçerli bir e-posta adresi girin.";
  if (!normalizeTurkishPhone(values.phone.trim())) errors.phone = "Geçerli bir cep telefonu numarası girin.";
  if (!values.subscriptionNumberUnknown) {
    const subscription = values.subscriptionNumber.trim();
    if (!subscription) errors.subscriptionNumber = "Bu numarayı girin.";
    else if (subscription.length < 3 || subscription.length > 64) {
      errors.subscriptionNumber = "Numara 3 ile 64 karakter arasında olmalıdır.";
    }
  }
  if (!values.privacyAccepted) errors.privacyAccepted = "Devam etmek için aydınlatma metnini onaylayın.";
  return errors;
}

export function buildApplicationPayload(values, subscriptionField) {
  return {
    applicant: {
      first_name: values.firstName.trim(),
      last_name: values.lastName.trim(),
      email: values.email.trim(),
      phone: normalizeTurkishPhone(values.phone.trim()),
    },
    identity: { include_national_id: false },
    subscription: {
      number_type: subscriptionField.type,
      label: subscriptionField.label,
      ...(values.subscriptionNumberUnknown
        ? {}
        : { value: values.subscriptionNumber.trim() }),
    },
    subscription_number_unknown: values.subscriptionNumberUnknown,
    privacy_notice_accepted: values.privacyAccepted,
  };
}

export function setSubscriptionUnknown(values, unknown) {
  return {
    ...values,
    subscriptionNumberUnknown: unknown,
    subscriptionNumber: unknown ? "" : values.subscriptionNumber,
  };
}

const API_FIELD_MAP = {
  first_name: "firstName",
  last_name: "lastName",
  email: "email",
  phone: "phone",
  national_id: "nationalId",
  identity: "nationalId",
  value: "subscriptionNumber",
  subscription: "subscriptionNumber",
  privacy_notice_accepted: "privacyAccepted",
};

const API_FIELD_MESSAGES = {
  firstName: "Adınızı kontrol edin.",
  lastName: "Soyadınızı kontrol edin.",
  email: "Geçerli bir e-posta adresi girin.",
  phone: "Geçerli bir cep telefonu numarası girin.",
  nationalId: "Geçerli bir T.C. kimlik numarası girin.",
  subscriptionNumber: "Abonelik numarasını kontrol edin veya bilmediğinizi belirtin.",
  privacyAccepted: "Devam etmek için aydınlatma metnini onaylayın.",
};

export function mapGenerateValidationErrors(error) {
  if (error?.response?.status !== 422) return {};
  const detail = error.response.data?.detail;
  if (!Array.isArray(detail)) return {};

  return detail.reduce((errors, item) => {
    const location = Array.isArray(item?.loc) ? item.loc : [];
    const apiField = [...location].reverse().find((part) => API_FIELD_MAP[part]);
    const field = API_FIELD_MAP[apiField];
    if (field && !errors[field]) {
      errors[field] = API_FIELD_MESSAGES[field];
    }
    return errors;
  }, {});
}

export function isCaseResult(value) {
  return !!value
    && typeof value.id === "string"
    && typeof value.created_at === "string"
    && typeof value.summary === "string"
    && Array.isArray(value.recommended_path)
    && typeof value.generated_text === "string"
    && Array.isArray(value.required_documents)
    && Array.isArray(value.follow_up_plan)
    && typeof value.disclaimer === "string";
}
